<app-page-header
    icon="group"
    title="Afiliados"
    subtitle="Listado de afiliados del sistema"
></app-page-header>

<div class="afiliados-area seguridad-animate-in">
    <div class="container">
        <!-- ================= Barra superior ================= -->
        <div class="barra-superior">
            <button
                type="button"
                class="ds-pill ds-pill--outline"
                routerLink="/afiliado-alta"
                matTooltip="Dar de alta un afiliado nuevo"
            >
                <span class="material-icons">person_add</span>
                Agregar afiliado
            </button>
        </div>

        <!-- ================= Buscador ================= -->
        <div class="busqueda">
            <div class="buscador">
                <span class="material-icons">search</span>
                <input
                    type="text"
                    [(ngModel)]="searchTerm"
                    (keyup.enter)="searchPersonas()"
                    placeholder="Nombre, apellido o DNI"
                    autocomplete="off"
                />
            </div>

            <div class="busqueda__acciones">
                <button
                    type="button"
                    class="ds-pill ds-pill--primary"
                    (click)="searchPersonas()"
                    [disabled]="flagBuscando || !searchTerm"
                    matTooltip="Buscar afiliados por nombre, apellido o DNI"
                >
                    <span class="material-icons" [class.girando]="flagBuscando">
                        {{ flagBuscando ? 'autorenew' : 'search' }}
                    </span>
                    {{ flagBuscando ? 'Buscando…' : 'Buscar' }}
                </button>
            </div>
        </div>

        <!-- ================= Filtro local ================= -->
        <div class="busqueda" *ngIf="searchPerformed && dataSource?.data?.length">
            <div class="buscador buscador--wide">
                <span class="material-icons">filter_alt</span>
                <input
                    type="text"
                    (keyup)="applyFilter($event)"
                    placeholder="Filtrar en los resultados: nombre, apellido, DNI o email..."
                    autocomplete="off"
                />
            </div>
        </div>

        <!-- ================= Tabla ================= -->
        <div
            class="tabla-wrapper"
            *ngIf="searchPerformed && (!flagLoaded || dataSource?.data?.length)"
        >
            <ng-container *ngIf="flagLoaded">
                <table mat-table [dataSource]="dataSource" matSort class="material-table">
                    <ng-container matColumnDef="nombre">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.nombrePersona || '—' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="apellido">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Apellido</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.apellidoPersona || '—' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="identificacion">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Documento</th>
                        <td mat-cell *matCellDef="let element">
                            <span class="mono">{{ element.identificacion || 'S/D' }}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="fechaNacimiento">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nacimiento</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.birth ? (element.birth | date: 'dd/MM/yyyy' : 'UTC') : '—' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                        <td mat-cell *matCellDef="let element">
                            <span class="contacto__sec">{{ element.email || '—' }}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="telefono">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Teléfono</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.telefono || '—' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="nacionalidad">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nacionalidad</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.paisNacimientoNombreEs || '—' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="_id">
                        <th mat-header-cell *matHeaderCellDef>Acciones</th>
                        <td mat-cell *matCellDef="let element" class="acciones-cell">
                            <div class="acciones-row">
                                <button
                                    type="button"
                                    class="ds-icon-btn afiliado-accion afiliado-accion--sede"
                                    (click)="
                                        element.signoSedes &&
                                            verDetalle(element.signoSedes[0], element._id)
                                    "
                                    [disabled]="!element.signoSedes"
                                    matTooltip="Ver la sede asignada al afiliado"
                                    aria-label="Ver sede asignada"
                                >
                                    <span class="material-icons">home</span>
                                </button>

                                <button
                                    type="button"
                                    class="ds-icon-btn afiliado-accion afiliado-accion--ver"
                                    (click)="verDetalleGecros(element)"
                                    matTooltip="Ver los datos del afiliado y su grupo familiar"
                                    aria-label="Ver datos del afiliado"
                                >
                                    <span class="material-icons">visibility</span>
                                </button>

                                <button
                                    type="button"
                                    class="ds-icon-btn afiliado-accion afiliado-accion--edit"
                                    (click)="verPersona(element._id)"
                                    matTooltip="Modificar los datos del afiliado"
                                    aria-label="Modificar afiliado"
                                >
                                    <span class="material-icons">edit_note</span>
                                </button>

                                <button
                                    type="button"
                                    class="ds-icon-btn afiliado-accion afiliado-accion--user"
                                    (click)="verUsuario(element._id)"
                                    matTooltip="Modificar los datos de la cuenta de usuario"
                                    aria-label="Modificar usuario"
                                >
                                    <span class="material-icons">manage_accounts</span>
                                </button>

                                <button
                                    type="button"
                                    class="ds-icon-btn afiliado-accion afiliado-accion--key"
                                    (click)="openDialogModificarClave(element._id)"
                                    matTooltip="Modificar la contraseña de la cuenta"
                                    aria-label="Modificar contraseña"
                                >
                                    <span class="material-icons">key</span>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
                            Sin coincidencias para "<strong>{{ searchTerm }}</strong>".
                        </td>
                    </tr>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>

                <mat-paginator
                    *ngIf="dataSource?.data?.length"
                    [pageSizeOptions]="[10, 25, 50, 100, 150, 200]"
                    showFirstLastButtons
                    aria-label="Selector de páginas"
                ></mat-paginator>
            </ng-container>
        </div>

        <!-- ================= Sin resultados ================= -->
        <div
            class="ds-empty"
            *ngIf="searchPerformed && flagLoaded && dataSource?.data?.length === 0"
        >
            <span class="material-icons">search_off</span>
            <p>
                No se encontraron afiliados que coincidan con "<strong>{{ searchTerm }}</strong>".
            </p>
            <button
                type="button"
                class="ds-pill ds-pill--outline ds-pill--sm"
                (click)="clearSearch()"
                matTooltip="Limpiar la búsqueda"
            >
                <span class="material-icons">restart_alt</span>
                Limpiar búsqueda
            </button>
        </div>
    </div>

    <app-spinner
        [show]="!flagLoaded"
        [text]="'Buscando afiliados'"
        [type]="'fullscreen'"
        [color]="'#B1476A'"
        [trackColor]="'#4CA7C8'"
        [blurBackground]="true"
    ></app-spinner>
</div>
